import { t } from '../i18n';
import { LAYOUT_CANVAS, serializeLayout } from './normalize';
import { LayoutDefinition, LayoutKind } from './types';

export function createDefaultLayout(kind: LayoutKind = 'simple'): LayoutDefinition {
  const canvas = LAYOUT_CANVAS[kind];
  return serializeLayout({
    kind,
    metadata: { name: t('layout.newName') },
    display: { width: canvas.width, height: canvas.height },
    widgets: [],
    layout: { zones: [] },
  });
}

export function slugifyLayoutName(name: string): string {
  const slug = name.toLowerCase().trim().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
  return slug || 'layout';
}
